import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../generic-ui/Pagination";
import Select from "../generic-ui/Select";
import NavbarIconsMenus from "../generic-nav-bar/NavbarIconsMenus";
import {
  menuStartDelete,
  selectMenus,
  startLoadingMenus,
  startLoadingMenusPaginated,
  startSearchingMenusPaginated,
} from "../../app/actions/menuActions";
import SearchBackMenu from "../generic-search/SearchBackMenu";

import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import TableMenus from "./TableMenus";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { startLoadingCatalogModules } from "../../app/actions/catalogModuleActions";
import { startLoadingCatalogRoles } from "../../app/actions/catalogRoleActions";

const ID_FORM = "admin-menu";
const OPERATION = "list";

const listOptions = [2, 3, 4, 5, 10, 15, 20, 25, 50, 100];

const ListMenus = () => {
  debugLogPages(':: ListMenus');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { trackEvent } = useTracking();
  const { t } = useTranslation();

  const { searchTextState, menuS, menusP, totalPagesP, totalItemsP, currentPageP, totalPagesS, totalItemsS, currentPageS } =
    useSelector((state) => state.menu);

  const [, setCurrentPageClick] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [pageInitial] = useState(0);
  const [searchText, setSearchText] = useState(searchTextState || "");

  useEffect(() => {
    dispatch(startLoadingMenusPaginated(pageInitial, itemsPerPage));
    dispatch(startLoadingMenus());
    dispatch(startLoadingCatalogModules());
    dispatch(startLoadingCatalogRoles());

    setSearchText("");
  }, []);

  const onEditRow = (row) => {
    trackEvent({ component: "EditMenus", method: "onEditRow", event: "EditMenus-Clicked" });

    dispatch(selectMenus(row));
    if (menuS && menuS.length > 0) {
      navigate("/admin-menu/edit-menu", {
        state: { searchTextNavListUser: searchText },
      });
    } else {
      navigate("/admin-menu/edit-menu");
    }
  };

  const onDeleteRow = (row) => {
    trackEvent({ component: "DeleteMenus", method: "onDeleteRow", event: "DeleteMenus-Clicked" });
    dispatch(menuStartDelete(row.id));
  };

  const onPageChange = (pageClick) => {
    
    if (menuS && menuS.length > 0) {
      dispatch(startSearchingMenusPaginated(searchText, pageClick - 1, itemsPerPage));
    } else {
      dispatch(startLoadingMenusPaginated(pageClick - 1, itemsPerPage));
    }
    setCurrentPageClick(pageClick);
  };

  const onChangeSelect = (event) => {
    setItemsPerPage(event.target.value);
    if (menuS && menuS.length > 0) {
      dispatch(startSearchingMenusPaginated(searchText, 0, event.target.value));
    } else {
      dispatch(startLoadingMenusPaginated(0, event.target.value));
    }
    setCurrentPageClick(0);
    setItemsPerPage(event.target.value);
  };

  return (
    <>
      <NavbarIconsMenus page={"listMenus"} />

      <div className="d-flex justify-content-center page-title">{t(`${ID_FORM}.page.${OPERATION}`)}</div>

      <hr className="line-hr" />

      <SearchBackMenu searchText={searchText} setSearchText={setSearchText} itemsPerPage={itemsPerPage} />

      {menuS && menuS.length > 0 ? (
        <TableMenus data={menuS} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      ) : (
        <TableMenus data={menusP} onEditRow={onEditRow} onDeleteRow={onDeleteRow} />
      )}

      <div>
        <Select listOptions={listOptions} onChangeSelect={onChangeSelect} pageSize={itemsPerPage} />
      </div>

      <div className="pagination justify-content-center">
        {menuS && menuS.length > 0 ? (
          <Pagination
            totalPages={totalPagesS}
            totalItems={totalItemsS}
            currentPage={currentPageS + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        ) : (
          <Pagination
            totalPages={totalPagesP}
            totalItems={totalItemsP}
            currentPage={currentPageP + 1} 
            itemsPerPage={itemsPerPage}
            onPageChange={onPageChange}
          />
        )}
      </div>
    </>
  );
};

export default ListMenus;
